import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import ProfileMenu from "./Menus/profileMenu";
import { connect } from "react-redux";
import { toggleSidebar } from "../../store/actions";
import { makeLayoutSelectField } from "store/layout/selector";

// import { getLoggedInUser } from '../../helpers/authUtils';

import logoLight from "../../images/logo-light.png";
import logoSmall from "../../images/logo-sm.png";

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      create_menu: false,
      istoggle: true,
    };
    this.toggleCreate = this.toggleCreate.bind(this);
  }

  componentDidMount() {
    this.toggleSidebarCheck();
    this.autoCloseSidebar();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.istoggle !== this.state.istoggle) {
      this.toggleSidebarCheck();
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.autoCloseSidebar();
    }
  }

  autoCloseSidebar = () => {
    if (window.outerWidth > 768) {
      if (!this.state.istoggle) {
        this.sidebarToggle();
      }
    } else {
      if (this.state.istoggle) {
        this.sidebarToggle();
      }
    }
  };

  toggleSidebarCheck = () => {
    if (this.state.istoggle) {
      document.body.classList.remove("enlarged");
    } else {
      document.body.classList.add("enlarged");
    }
  };

  toggleCreate() {
    this.setState((prevState) => ({
      create_menu: !prevState.create_menu,
    }));
  }

  sidebarToggle = () => {
    this.setState((prevState) => ({
      istoggle: !prevState.istoggle,
    }));
    this.props.toggleSidebar(!this.props.is_toggle);
  };

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="topbar">
          <div className="topbar-left">
            <Link to="/" className="logo">
              <span className="logo-light">
                <img src={logoLight} alt="" height="16" />
              </span>
              <span className="logo-sm">
                <img src={logoSmall} alt="" height="22" />
              </span>
            </Link>
          </div>

          <nav className="navbar-custom">
            <ul className="navbar-right list-inline float-right mb-0">
              <li className="dropdown notification-list list-inline-item d-none d-md-inline-block mr-1">
                <Link
                  onClick={this.toggleFullscreen}
                  className="nav-link waves-effect"
                  to="#"
                  id="btn-fullscreen"
                >
                  <i className="ion ion-md-qr-scanner noti-icon"></i>
                </Link>
              </li>

              <ProfileMenu />
            </ul>

            <ul className="list-inline menu-left mb-0">
              <li className="float-left">
                <button
                  onClick={this.sidebarToggle}
                  className="button-menu-mobile open-left waves-effect"
                >
                  <i className="mdi mdi-menu"></i>
                </button>
              </li>

              <li className="d-none d-sm-block"></li>
            </ul>
          </nav>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const is_toggle = makeLayoutSelectField("is_toggle");
  return { is_toggle };
};

export default withRouter(connect(mapStatetoProps, { toggleSidebar })(Topbar));
